import { StoryNode } from "../StoryBook/StoryData";
import { useState } from "react";
import { UIToggleButtons } from "./UIToggleButtons";
import { UITextList } from "./UITextList";
import { UISelect } from "./UISelect";
import { HTMLDisplayType, UIHTMLDisplay } from "./UIHTMLDisplay";
import { UIColorPickerTextField } from "./UIColorPickerTextField";
import { UIDatePicker } from "./UIDatePicker";
import { UIErrorDisplay } from "./UIErrorDisplay";
import { ValidationIssue } from "../../rule-engine-core/Common/IDesignValidationProvider";
import { UIDropdownMenu } from "./UIDropdownMenu";
import { UILabel } from "./UILabel";
import { Box, Button, TextField } from "@mui/material";
import { UIFontSelect } from "./UIFontSelect";
import { UIIconButton } from "./UIIconButton";
import { BoldIcon } from "../Icon/BoldIcon";
import { UINumberList } from "./UINumberList";
import { UIRadioButton } from "./UIRadioButton";
import { UIRadioGroup } from "./UIRadioGroup";
import { UISwitch } from "./UISwitch";
import { ItalicIcon } from "../Icon/ItalicIcon";
import { UIObjectList } from "./UIObjectList";
import { PropertyEditorText } from "../PropertyEditing/PropertyEditorText";
import { PropertyEditorInteger } from "../PropertyEditing/PropertyEditorInteger";
import { PropertyEditorBoolean } from "../PropertyEditing/PropertyEditorBoolean";
import { UICollapse } from "./UICollapse";
import { UIValidationTooltip } from "./UIValidationTooltip";
import { UISearchControl, UISearchControlItem } from "./UISearchControl";

class Person {
    name?: string;
    age?: number;
    isMale?: boolean;

    constructor(name?: string, age?: number, isMale?: boolean) {
        this.name = name;
        this.age = age;
        this.isMale = isMale;
    }
}

const people: Person[] = [new Person("carl", 30, true), new Person("jill", 40, false)];
const people_empty: Person[] = [];

async function search(_search: string): Promise<UISearchControlItem<Person>[]> {
    return [
        new UISearchControlItem<Person>("carl", new Person("carl", 30, true)),
        new UISearchControlItem<Person>("fred", new Person("fred", 30, true)),
        new UISearchControlItem<Person>("ally", new Person("ally", 30, true)),
    ];
}

async function searchOne(_search: string): Promise<UISearchControlItem<Person>[]> {
    return [new UISearchControlItem<Person>("carl", new Person("carl", 30, true))];
}
export const BuildingBlockStoriesNormal = [
    new StoryNode(
        () => {
            return (
                <UIValidationTooltip
                    validationIssues={[new ValidationIssue("issue 1"), new ValidationIssue("issue 2")]}
                >
                    <TextField></TextField>
                </UIValidationTooltip>
            );
        },

        "Shared",
        "Building Blocks",
        "Validation Issue Tooltip",
    ),

    new StoryNode(
        (logCallback) => {
            return (
                <UITextList
                    value={["a"]}
                    onChange={(v) => {
                        logCallback(v.join("\n"));
                    }}
                />
            );
        },

        "Shared",
        "Building Blocks",
        "String List",
        "Simple",
    ),
    new StoryNode(
        (logCallback) => {
            return (
                <UITextList
                    value={["a"]}
                    validValues={["a", "b", "c"]}
                    onChange={(v) => {
                        logCallback(v.join("\n"));
                    }}
                />
            );
        },

        "Shared",
        "Building Blocks",
        "String List",
        "Valid Values",
    ),

    new StoryNode(
        (logCallback) => {
            return (
                <UISelect
                    sx={{ width: "100%" }}
                    value={"a"}
                    options={["a", "b", "c"]}
                    onChange={(v) => {
                        logCallback(v ?? "undefined");
                    }}
                />
            );
        },

        "Shared",
        "Building Blocks",
        "Select",
    ),
    new StoryNode(
        () => {
            return (
                <UIHTMLDisplay
                    displayType={HTMLDisplayType.div}
                    html={"<p>some text<b>and bold</b></p>"}
                />
            );
        },
        "Shared",
        "Building Blocks",
        "HTML Display",
        "div",
    ),
    new StoryNode(
        () => {
            return (
                <UIHTMLDisplay
                    displayType={HTMLDisplayType.span}
                    html={"<p>some text<b>and bold</b></p>"}
                />
            );
        },
        "Shared",
        "Building Blocks",
        "HTML Display",
        "span",
    ),
    new StoryNode(
        (logCallback) => {
            return (
                <UIColorPickerTextField
                    value={"red"}
                    onChange={(v) => logCallback(v!)}
                />
            );
        },
        "Shared",
        "Building Blocks",
        "Color Picker",
    ),

    new StoryNode(
        (logCallback) => {
            let [val, setVal] = useState<Date>(new Date());

            return (
                <UIDatePicker
                    value={val}
                    onChange={(v) => {
                        setVal(v!);
                        logCallback(v!.toISOString());
                    }}
                />
            );
        },
        "Shared",
        "Building Blocks",
        "Date Picker",
        "Only Date",
    ),
    new StoryNode(
        (logCallback) => {
            let [val, setVal] = useState<Date | undefined>(undefined);

            return (
                <UIDatePicker
                    value={val}
                    onChange={(v) => {
                        setVal(v);
                        logCallback(v!.toISOString());
                    }}
                />
            );
        },
        "Shared",
        "Building Blocks",
        "Date Picker",
        "Only Date - Empty",
    ),
    new StoryNode(
        (logCallback) => {
            let [val, setVal] = useState<Date>(new Date());

            return (
                <UIDatePicker
                    value={val}
                    showTime={true}
                    onChange={(v) => {
                        setVal(v!);
                        logCallback(v!.toISOString());
                    }}
                />
            );
        },
        "Shared",
        "Building Blocks",
        "Date Picker",
        "With Time",
    ),

    new StoryNode(
        (logCallback) => {
            let [val, setVal] = useState<Date | undefined>();

            return (
                <UIDatePicker
                    value={val}
                    showTime={true}
                    onChange={(v) => {
                        setVal(v);
                        logCallback(v!.toISOString());
                    }}
                />
            );
        },
        "Shared",
        "Building Blocks",
        "Date Picker",
        "With Time - Empty",
    ),

    new StoryNode(
        () => {
            return <UIErrorDisplay validationBreaks={[new ValidationIssue("test"), new ValidationIssue("test2")]} />;
        },
        "Shared",
        "Building Blocks",
        "Error Display",
    ),
    new StoryNode(
        () => {
            return (
                <Box
                    padding={"10px"}
                    bgcolor={"blue"}
                >
                    <UIDropdownMenu
                        items={[
                            { renderUI: () => <UILabel>first</UILabel> },
                            { renderUI: () => <UILabel>second</UILabel> },
                        ]}
                        title={"test"}
                    />
                </Box>
            );
        },
        "Shared",
        "Building Blocks",
        "Drop Down Menu",
    ),
    new StoryNode(
        (logCallback) => {
            return (
                <UIFontSelect
                    sx={{ width: "200px" }}
                    onChange={(v) => {
                        logCallback(v);
                    }}
                />
            );
        },
        "Shared",
        "Building Blocks",
        "Font Select",
    ),

    new StoryNode(
        (logCallback) => {
            return (
                <Box
                    display={"flex"}
                    flexDirection={"row"}
                >
                    <UIIconButton
                        sx={{ border: "1px solid blue" }}
                        icon={<BoldIcon />}
                        onClick={() => logCallback("clicked")}
                    />
                </Box>
            );
        },
        "Shared",
        "Building Blocks",
        "Icon Button",
    ),
    new StoryNode(
        () => {
            return (
                <Box
                    display={"flex"}
                    flexDirection={"column"}
                >
                    <UILabel variant={"page_heading_large"}>page heading large</UILabel>
                    <UILabel variant={"page_heading"}>page heading</UILabel>
                    <UILabel variant={"section_title"}>section title</UILabel>
                    <UILabel variant={"title"}>title</UILabel>
                    <UILabel variant={"large"}>large</UILabel>
                    <UILabel variant={"medium"}>medium</UILabel>
                    <UILabel variant={"small"}>small</UILabel>
                    <UILabel variant={"verySmall"}>very small</UILabel>
                    <UILabel variant={"normal"}>normal</UILabel>
                    <UILabel variant={"label"}>label</UILabel>
                    <UILabel variant={"value"}>value</UILabel>
                    <UILabel>default</UILabel>
                </Box>
            );
        },
        "Shared",
        "Building Blocks",
        "Label",
    ),
    new StoryNode(
        (logCallback) => {
            return (
                <Box
                    display={"flex"}
                    flexDirection={"column"}
                >
                    <UINumberList
                        value={[1, 2, 3]}
                        onChange={(v) => {
                            let s = "";
                            v.forEach((n) => (s = s + n + ", "));
                            logCallback(s);
                        }}
                    ></UINumberList>
                </Box>
            );
        },
        "Shared",
        "Building Blocks",
        "Number List",
    ),
    new StoryNode(
        (logCallback) => {
            let [val, setVal] = useState<boolean>(true);
            return (
                <Box
                    display={"flex"}
                    flexDirection={"row"}
                >
                    <UIRadioButton
                        checked={val}
                        onClick={() => {
                            setVal(!val);
                            logCallback(!val + "");
                        }}
                    ></UIRadioButton>
                </Box>
            );
        },
        "Shared",
        "Building Blocks",
        "Radio Button",
    ),

    new StoryNode(
        (logCallback) => {
            let [val, setVal] = useState<string>("a");
            return (
                <Box
                    display={"flex"}
                    flexDirection={"row"}
                >
                    <UIRadioGroup
                        value={val}
                        items={[{ value: "a" }, { value: "b" }]}
                        onChange={(v) => {
                            if (v) {
                                setVal(v);
                                logCallback(v);
                            }
                        }}
                    ></UIRadioGroup>
                </Box>
            );
        },
        "Shared",
        "Building Blocks",
        "Radio Button Group",
    ),
    new StoryNode(
        (logCallback) => {
            let [val, setVal] = useState<boolean>(false);
            return (
                <Box
                    display={"flex"}
                    flexDirection={"row"}
                >
                    <UISwitch
                        value={val}
                        onChange={(v) => {
                            setVal(v);
                            logCallback(v + "");
                        }}
                    ></UISwitch>
                </Box>
            );
        },
        "Shared",
        "Building Blocks",
        "Switch",
    ),

    new StoryNode(
        (logCallback) => {
            let [val, setVal] = useState<string>("a");
            return (
                <Box
                    display={"flex"}
                    flexDirection={"row"}
                >
                    <UIToggleButtons
                        options={[{ value: "a" }, { value: "b" }]}
                        value={val}
                        onChange={(v) => {
                            if (v) {
                                setVal(v);
                                logCallback(v);
                            }
                        }}
                    ></UIToggleButtons>
                </Box>
            );
        },
        "Shared",
        "Building Blocks",
        "Toggle Buttons",
        "Value",
    ),
    new StoryNode(
        (logCallback) => {
            let [val, setVal] = useState<string>("a");
            return (
                <Box
                    display={"flex"}
                    flexDirection={"row"}
                >
                    <UIToggleButtons
                        options={[
                            { value: "a", text: "a text" },
                            { value: "b", text: "b text" },
                        ]}
                        value={val}
                        onChange={(v) => {
                            if (v) {
                                setVal(v);
                                logCallback(v);
                            }
                        }}
                    ></UIToggleButtons>
                </Box>
            );
        },
        "Shared",
        "Building Blocks",
        "Toggle Buttons",
        "Text",
    ),
    new StoryNode(
        (logCallback) => {
            let [val, setVal] = useState<string>("a");
            return (
                <Box
                    display={"flex"}
                    flexDirection={"row"}
                >
                    <UIToggleButtons
                        options={[
                            {
                                value: "a",
                                renderIcon: () => <BoldIcon />,
                            },
                            {
                                value: "b",
                                renderIcon: () => <ItalicIcon />,
                            },
                        ]}
                        value={val}
                        onChange={(v) => {
                            if (v) {
                                setVal(v);
                                logCallback(v);
                            }
                        }}
                    ></UIToggleButtons>
                </Box>
            );
        },
        "Shared",
        "Building Blocks",
        "Toggle Buttons",
        "Icon",
    ),

    new StoryNode(
        (logCallback) => {
            let [val, setVal] = useState<string>("a");
            return (
                <Box
                    display={"flex"}
                    flexDirection={"row"}
                >
                    <UIToggleButtons
                        options={[
                            {
                                value: "a",
                                renderUI: (selected) => (
                                    <UILabel
                                        color={selected ? "white" : "red"}
                                        variant={"page_heading"}
                                    >
                                        a text
                                    </UILabel>
                                ),
                            },
                            {
                                value: "b",
                                renderUI: (selected) => (
                                    <UILabel
                                        color={selected ? "white" : "red"}
                                        variant={"page_heading"}
                                    >
                                        b text
                                    </UILabel>
                                ),
                            },
                        ]}
                        value={val}
                        onChange={(v) => {
                            if (v) {
                                setVal(v);
                                logCallback(v);
                            }
                        }}
                    ></UIToggleButtons>
                </Box>
            );
        },
        "Shared",
        "Building Blocks",
        "Toggle Buttons",
        "Render UI",
    ),
    new StoryNode(
        () => {
            return (
                <UIToggleButtons
                    options={["a", "b"]}
                    value={"a"}
                    onChange={() => {}}
                />
            );
        },

        "Shared",
        "Building Blocks",
        "Toggle Buttons",
        "string array",
    ),
    new StoryNode(
        () => {
            return (
                <UIObjectList<Person>
                    values={people}
                    renderItemUI={(item) => {
                        return (
                            <Box
                                display={"flex"}
                                flexDirection={"column"}
                            >
                                <PropertyEditorText
                                    editObject={item}
                                    propertyName={"name"}
                                />
                                <PropertyEditorInteger
                                    editObject={item}
                                    propertyName={"age"}
                                />
                                <PropertyEditorBoolean
                                    editObject={item}
                                    propertyName={"isMale"}
                                />
                            </Box>
                        );
                    }}
                    getItemName={(item) => item.name ?? "Undefined"}
                    createNewItem={() => new Person()}
                />
            );
        },
        "Shared",
        "Building Blocks",
        "Object List",
        "Default",
    ),

    new StoryNode(
        () => {
            return (
                <UIObjectList<Person>
                    values={people_empty}
                    renderItemUI={(item) => {
                        return (
                            <Box
                                display={"flex"}
                                flexDirection={"column"}
                            >
                                <PropertyEditorText
                                    editObject={item}
                                    propertyName={"name"}
                                />
                                <PropertyEditorInteger
                                    editObject={item}
                                    propertyName={"age"}
                                />
                                <PropertyEditorBoolean
                                    editObject={item}
                                    propertyName={"isMale"}
                                />
                            </Box>
                        );
                    }}
                    getItemName={(item) => item.name ?? "Undefined"}
                    createNewItem={() => new Person()}
                />
            );
        },
        "Shared",
        "Building Blocks",
        "Object List",
        "No Data",
    ),

    new StoryNode(
        () => {
            let [show, setShow] = useState<boolean>(true);
            return (
                <Box
                    display={"flex"}
                    flexDirection={"column"}
                >
                    <Button onClick={() => setShow(!show)}>Toggle</Button>
                    <UICollapse in={show}>show this</UICollapse>
                </Box>
            );
        },
        "Shared",
        "Building Blocks",
        "Collapse",
    ),

    new StoryNode(
        (l) => {
            let [val, setVal] = useState<UISearchControlItem<Person>[]>([]);
            return (
                <Box
                    display={"flex"}
                    flexDirection={"column"}
                >
                    <UISearchControl<Person>
                        multiSelect={false}
                        label="search for people"
                        searchTitle={"Find Person"}
                        value={val}
                        searchItems={searchOne}
                        onChange={(i) => {
                            l("items " + i?.map((i) => i.name).join(", "));
                            setVal(i ?? []);
                        }}
                    />
                </Box>
            );
        },
        "Shared",
        "Building Blocks",
        "Search Control",
        "Single Value",
    ),

    new StoryNode(
        (l) => {
            let [val, setVal] = useState<UISearchControlItem<Person>[]>([]);
            return (
                <Box
                    display={"flex"}
                    flexDirection={"column"}
                    width={"500px"}
                >
                    <UISearchControl<Person>
                        multiSelect={false}
                        label="search for people"
                        searchTitle={"Find Person"}
                        value={val}
                        searchItems={search}
                        onChange={(i) => {
                            l("items " + i?.map((i) => i.name).join(", "));
                            setVal(i ?? []);
                        }}
                    />
                </Box>
            );
        },
        "Shared",
        "Building Blocks",
        "Search Control",
        "Normal",
    ),

    new StoryNode(
        (l) => {
            let [val, setVal] = useState<UISearchControlItem<Person>[]>([
                new UISearchControlItem<Person>("carl", new Person("carl", 30, true)),
            ]);
            return (
                <Box
                    display={"flex"}
                    flexDirection={"column"}
                >
                    <UISearchControl<Person>
                        multiSelect={false}
                        label="search for people"
                        searchTitle={"Find Person"}
                        value={val}
                        searchItems={search}
                        onChange={(i) => {
                            l("items " + i?.map((i) => i.name).join(", "));
                            setVal(i ?? []);
                        }}
                    />
                </Box>
            );
        },
        "Shared",
        "Building Blocks",
        "Search Control",
        "With value",
    ),
    new StoryNode(
        (l) => {
            let [val, setVal] = useState<UISearchControlItem<Person>[]>([
                new UISearchControlItem<Person>("carl", new Person("carl", 30, true)),
            ]);
            return (
                <Box
                    display={"flex"}
                    flexDirection={"column"}
                >
                    <UISearchControl<Person>
                        multiSelect={false}
                        hint="some hint"
                        label="search for people"
                        searchTitle={"Find Person"}
                        value={val}
                        searchItems={search}
                        onChange={(i) => {
                            l("items " + i?.map((i) => i.name).join(", "));
                            setVal(i ?? []);
                        }}
                    />
                </Box>
            );
        },
        "Shared",
        "Building Blocks",
        "Search Control",
        "With hint",
    ),
    new StoryNode(
        (l) => {
            let [val, setVal] = useState<UISearchControlItem<Person>[]>([
                new UISearchControlItem<Person>("carl", new Person("carl", 30, true)),
            ]);
            return (
                <Box
                    display={"flex"}
                    flexDirection={"column"}
                >
                    <UISearchControl<Person>
                        multiSelect={false}
                        error="some error"
                        label="search for people"
                        searchTitle={"Find Person"}
                        value={val}
                        searchItems={search}
                        onChange={(i) => {
                            l("items " + i?.map((i) => i.name).join(", "));
                            setVal(i ?? []);
                        }}
                    />
                </Box>
            );
        },
        "Shared",
        "Building Blocks",
        "Search Control",
        "With error",
    ),

    new StoryNode(
        (l) => {
            let [val, setVal] = useState<UISearchControlItem<Person>[]>([]);
            return (
                <Box
                    display={"flex"}
                    flexDirection={"column"}
                >
                    <UISearchControl<Person>
                        multiSelect={true}
                        label="search for people"
                        searchTitle={"Find Person"}
                        value={val}
                        searchItems={searchOne}
                        onChange={(i) => {
                            l("items " + i?.map((i) => i.name).join(", "));
                            setVal(i ?? []);
                        }}
                    />
                </Box>
            );
        },
        "Shared",
        "Building Blocks",
        "Search Control - Multi",
        "Single",
    ),

    new StoryNode(
        (l) => {
            let [val, setVal] = useState<UISearchControlItem<Person>[]>([]);
            return (
                <Box
                    display={"flex"}
                    flexDirection={"column"}
                >
                    <UISearchControl<Person>
                        multiSelect={true}
                        label="search for people"
                        searchTitle={"Find Person"}
                        value={val}
                        searchItems={search}
                        onChange={(i) => {
                            l("items " + i?.map((i) => i.name).join(", "));
                            setVal(i ?? []);
                        }}
                    />
                </Box>
            );
        },
        "Shared",
        "Building Blocks",
        "Search Control - Multi",
        "Normal",
    ),

    new StoryNode(
        (l) => {
            let [val, setVal] = useState<UISearchControlItem<Person>[]>([
                new UISearchControlItem<Person>("carl", new Person("carl", 30, true)),
            ]);
            return (
                <Box
                    display={"flex"}
                    flexDirection={"column"}
                >
                    <UISearchControl<Person>
                        multiSelect={true}
                        label="search for people"
                        searchTitle={"Find Person"}
                        value={val}
                        searchItems={search}
                        onChange={(i) => {
                            l("items " + i?.map((i) => i.name).join(", "));
                            setVal(i ?? []);
                        }}
                    />
                </Box>
            );
        },
        "Shared",
        "Building Blocks",
        "Search Control - Multi",
        "With value",
    ),
    new StoryNode(
        (l) => {
            let [val, setVal] = useState<UISearchControlItem<Person>[]>([
                new UISearchControlItem<Person>("carl", new Person("carl", 30, true)),
            ]);
            return (
                <Box
                    display={"flex"}
                    flexDirection={"column"}
                >
                    <UISearchControl<Person>
                        multiSelect={true}
                        hint="some hint"
                        label="search for people"
                        searchTitle={"Find Person"}
                        value={val}
                        searchItems={search}
                        onChange={(i) => {
                            l("items " + i?.map((i) => i.name).join(", "));
                            setVal(i ?? []);
                        }}
                    />
                </Box>
            );
        },
        "Shared",
        "Building Blocks",
        "Search Control - Multi",
        "With hint",
    ),
    new StoryNode(
        (l) => {
            let [val, setVal] = useState<UISearchControlItem<Person>[]>([
                new UISearchControlItem<Person>("carl", new Person("carl", 30, true)),
            ]);
            return (
                <Box
                    display={"flex"}
                    flexDirection={"column"}
                >
                    <UISearchControl<Person>
                        multiSelect={true}
                        error="some error"
                        label="search for people"
                        searchTitle={"Find Person"}
                        value={val}
                        searchItems={search}
                        onChange={(i) => {
                            l("items " + i?.map((i) => i.name).join(", "));
                            setVal(i ?? []);
                        }}
                    />
                </Box>
            );
        },
        "Shared",
        "Building Blocks",
        "Search Control - Multi",
        "With error",
    ),
];

export const BuildingBlockStoriesError = [
    new StoryNode(
        (logCallback) => {
            return (
                <UITextList
                    value={["a"]}
                    error={"error text"}
                    onChange={(v) => {
                        logCallback(v.join("\n"));
                    }}
                />
            );
        },

        "Shared",
        "Building Blocks",
        "String List",
        "Simple - Error",
    ),
    new StoryNode(
        (logCallback) => {
            return (
                <UITextList
                    value={["a"]}
                    error={"error text"}
                    validValues={["a", "b", "c"]}
                    onChange={(v) => {
                        logCallback(v.join("\n"));
                    }}
                />
            );
        },

        "Shared",
        "Building Blocks",
        "String List",
        "Valid Values - Error",
    ),

    new StoryNode(
        (logCallback) => {
            return (
                <UISelect
                    sx={{ width: "100%" }}
                    value={"a"}
                    error={"error text"}
                    options={["a", "b", "c"]}
                    onChange={(v) => {
                        logCallback(v ?? "undefined");
                    }}
                />
            );
        },

        "Shared",
        "Building Blocks",
        "Select - Error",
    ),
    new StoryNode(
        (logCallback) => {
            return (
                <UIColorPickerTextField
                    value={"red"}
                    error={"error text"}
                    onChange={(v) => logCallback(v!)}
                />
            );
        },
        "Shared",
        "Building Blocks",
        "Color Picker - Error",
    ),

    new StoryNode(
        (logCallback) => {
            let [val, setVal] = useState<Date>(new Date());

            return (
                <UIDatePicker
                    value={val}
                    error={"error text"}
                    onChange={(v) => {
                        setVal(v!);
                        logCallback(v!.toISOString());
                    }}
                />
            );
        },
        "Shared",
        "Building Blocks",
        "Date Picker",
        "Only Date - Error",
    ),
    new StoryNode(
        (logCallback) => {
            let [val, setVal] = useState<Date>(new Date());

            return (
                <UIDatePicker
                    value={val}
                    showTime={true}
                    error={"error text"}
                    onChange={(v) => {
                        setVal(v!);
                        logCallback(v!.toISOString());
                    }}
                />
            );
        },
        "Shared",
        "Building Blocks",
        "Date Picker",
        "With Time - Error",
    ),
    new StoryNode(
        (logCallback) => {
            return (
                <UIFontSelect
                    sx={{ width: "200px" }}
                    error={"error text"}
                    onChange={(v) => {
                        logCallback(v);
                    }}
                />
            );
        },
        "Shared",
        "Building Blocks",
        "Font Select - Error",
    ),

    new StoryNode(
        (logCallback) => {
            return (
                <Box
                    display={"flex"}
                    flexDirection={"column"}
                >
                    <UINumberList
                        error={"error text"}
                        value={[1, 2, 3]}
                        onChange={(v) => {
                            let s = "";
                            v.forEach((n) => (s = s + n + ", "));
                            logCallback(s);
                        }}
                    ></UINumberList>
                </Box>
            );
        },
        "Shared",
        "Building Blocks",
        "Number List - Error",
    ),
    new StoryNode(
        (logCallback) => {
            let [val, setVal] = useState<string>("a");
            return (
                <Box
                    display={"flex"}
                    flexDirection={"row"}
                >
                    <UIRadioGroup
                        error={"error text"}
                        value={val}
                        items={[{ value: "a" }, { value: "b" }]}
                        onChange={(v) => {
                            if (v) {
                                setVal(v);
                                logCallback(v);
                            }
                        }}
                    ></UIRadioGroup>
                </Box>
            );
        },
        "Shared",
        "Building Blocks",
        "Radio Button Group - Error",
    ),
    new StoryNode(
        (logCallback) => {
            let [val, setVal] = useState<boolean>(false);
            return (
                <Box
                    display={"flex"}
                    flexDirection={"row"}
                >
                    <UISwitch
                        error={"error text"}
                        value={val}
                        onChange={(v) => {
                            setVal(v);
                            logCallback(v + "");
                        }}
                    ></UISwitch>
                </Box>
            );
        },
        "Shared",
        "Building Blocks",
        "Switch - Error",
    ),

    new StoryNode(
        (logCallback) => {
            let [val, setVal] = useState<boolean>(false);
            return (
                <Box
                    display={"flex"}
                    flexDirection={"row"}
                >
                    <UISwitch
                        label={"Boolean Label"}
                        hint={"hint text"}
                        value={val}
                        onChange={(v) => {
                            setVal(v);
                            logCallback(v + "");
                        }}
                    ></UISwitch>
                </Box>
            );
        },
        "Shared",
        "Building Blocks",
        "Switch - Label",
    ),

    new StoryNode(
        (logCallback) => {
            let [val, setVal] = useState<string>("a");
            return (
                <Box
                    display={"flex"}
                    flexDirection={"row"}
                >
                    <UIToggleButtons
                        error={"error text"}
                        options={[{ value: "a" }, { value: "b" }]}
                        value={val}
                        onChange={(v) => {
                            if (v) {
                                setVal(v);
                                logCallback(v);
                            }
                        }}
                    ></UIToggleButtons>
                </Box>
            );
        },
        "Shared",
        "Building Blocks",
        "Toggle Buttons",
        "Value - Error",
    ),
    new StoryNode(
        (logCallback) => {
            let [val, setVal] = useState<string>("a");
            return (
                <Box
                    display={"flex"}
                    flexDirection={"row"}
                >
                    <UIToggleButtons
                        error={"error text"}
                        options={[
                            { value: "a", text: "a text" },
                            { value: "b", text: "b text" },
                        ]}
                        value={val}
                        onChange={(v) => {
                            if (v) {
                                setVal(v);
                                logCallback(v);
                            }
                        }}
                    ></UIToggleButtons>
                </Box>
            );
        },
        "Shared",
        "Building Blocks",
        "Toggle Buttons",
        "Text - Error",
    ),
    new StoryNode(
        (logCallback) => {
            let [val, setVal] = useState<string>("a");
            return (
                <Box
                    display={"flex"}
                    flexDirection={"row"}
                >
                    <UIToggleButtons
                        error={"error text"}
                        options={[
                            {
                                value: "a",
                                renderIcon: () => <BoldIcon />,
                            },
                            {
                                value: "b",
                                renderIcon: () => <ItalicIcon />,
                            },
                        ]}
                        value={val}
                        onChange={(v) => {
                            if (v) {
                                setVal(v);
                                logCallback(v);
                            }
                        }}
                    ></UIToggleButtons>
                </Box>
            );
        },
        "Shared",
        "Building Blocks",
        "Toggle Buttons",
        "Icon - Error",
    ),

    new StoryNode(
        (logCallback) => {
            let [val, setVal] = useState<string>("a");
            return (
                <Box
                    display={"flex"}
                    flexDirection={"row"}
                >
                    <UIToggleButtons
                        error={"error text"}
                        options={[
                            {
                                value: "a",
                                renderUI: (selected) => (
                                    <UILabel
                                        color={selected ? "white" : "red"}
                                        variant={"page_heading"}
                                    >
                                        a text
                                    </UILabel>
                                ),
                            },
                            {
                                value: "b",
                                renderUI: (selected) => (
                                    <UILabel
                                        color={selected ? "white" : "red"}
                                        variant={"page_heading"}
                                    >
                                        b text
                                    </UILabel>
                                ),
                            },
                        ]}
                        value={val}
                        onChange={(v) => {
                            if (v) {
                                setVal(v);
                                logCallback(v);
                            }
                        }}
                    ></UIToggleButtons>
                </Box>
            );
        },
        "Shared",
        "Building Blocks",
        "Toggle Buttons",
        "Render UI - Error",
    ),
    new StoryNode(
        () => {
            return (
                <UIToggleButtons
                    error={"error text"}
                    options={["a", "b"]}
                    value={"a"}
                    onChange={() => {}}
                />
            );
        },

        "Shared",
        "Building Blocks",
        "Toggle Buttons",
        "string array - Error",
    ),
    new StoryNode(
        () => {
            return (
                <UIObjectList<Person>
                    error={"error text"}
                    values={people}
                    renderItemUI={(item) => {
                        return (
                            <Box
                                display={"flex"}
                                flexDirection={"column"}
                            >
                                <PropertyEditorText
                                    editObject={item}
                                    propertyName={"name"}
                                />
                                <PropertyEditorInteger
                                    editObject={item}
                                    propertyName={"age"}
                                />
                                <PropertyEditorBoolean
                                    editObject={item}
                                    propertyName={"isMale"}
                                />
                            </Box>
                        );
                    }}
                    getItemName={(item) => item.name ?? "Undefined"}
                    createNewItem={() => new Person()}
                />
            );
        },
        "Shared",
        "Building Blocks",
        "Object List",
        "Default - Error",
    ),

    new StoryNode(
        () => {
            return (
                <UIObjectList<Person>
                    error={"error text"}
                    values={people_empty}
                    renderItemUI={(item) => {
                        return (
                            <Box
                                display={"flex"}
                                flexDirection={"column"}
                            >
                                <PropertyEditorText
                                    editObject={item}
                                    propertyName={"name"}
                                />
                                <PropertyEditorInteger
                                    editObject={item}
                                    propertyName={"age"}
                                />
                                <PropertyEditorBoolean
                                    editObject={item}
                                    propertyName={"isMale"}
                                />
                            </Box>
                        );
                    }}
                    getItemName={(item) => item.name ?? "Undefined"}
                    createNewItem={() => new Person()}
                />
            );
        },
        "Shared",
        "Building Blocks",
        "Object List",
        "No Data - Error",
    ),
];

export const BuildlingBlockStories = [...BuildingBlockStoriesNormal, ...BuildingBlockStoriesError];
